<template>
  <span class="tag" :class="{ selected: isSelected }" @click="toggleSelect">
    {{ label }}
    <span v-if="isCustom" class="tag__remove" @click.stop="removeTag">×</span>
  </span>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  isSelected: { type: Boolean, default: false },
  isCustom: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle', 'remove']);

const toggleSelect = () => {
  emit('toggle', props.label);
};

const removeTag = () => {
  emit('remove', props.label);
};
</script>

<style scoped>
.tag {
  position: relative;
  display: inline-block;
  padding: 6px 8px;
  border: 1px solid var(--constant-grey13);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--constant-grey);
  background-color: var(--constant-white);
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 100%;
}

.tag:hover {
  background-color: var(--constant-grey13);
  color: var(--constant-white);
  .tag__remove {
    opacity: 1;
    transform: scale(1);
  }
}

.selected {
  background-color: var(--constant-grey13);
  color: var(--constant-white);
}

:root[scheme='dark'] .tag {
  border: 1px solid var(--constant-grey5);
  color: var(--constant-grey-light);
  background-color: var(--constant-black);
}

:root[scheme='dark'] .tag:hover {
  background-color: var(--constant-grey-light5);
  color: var(--constant-black);
}

:root[scheme='dark'] .selected {
  background-color: var(--constant-grey-light5);
  color: var(--constant-black);
}

.tag__remove {
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: var(--interactive-02);
  color: var(--text-01);
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  z-index: 1;
  opacity: 0;
  transform: scale(0.8);
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.tag__remove:hover {
  background: var(--constant-grey-light);
}
:root[scheme='dark'] .tag__remove:hover {
  background: var(--constant-grey8);
}
</style>
